import { render, staticRenderFns } from "./callBoard.vue?vue&type=template&id=16b600d0&scoped=true"
import script from "./callBoard.vue?vue&type=script&lang=ts"
export * from "./callBoard.vue?vue&type=script&lang=ts"
import style0 from "./callBoard.vue?vue&type=style&index=0&id=16b600d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b600d0",
  null
  
)

export default component.exports